import React from "react";

export default function AfriMedAuthMobileRail({
  title = "Welcome to AfriMed™",
  subtitle = null,
  logoAlt = "AfriMed™",
  children,
  supportSlot = null,
  footerSlot = null,
  desktopAside = null,
  outerClassName = "auth-bg h-[100dvh] w-full overflow-hidden px-4",
  layoutClassName = "",
  contentClassName = "w-full max-w-[375px] text-center",
  contentWrapClassName = "",
  logoClassName = "mx-auto mb-12 h-auto w-[135px]",
  headerClassName = "text-center",
  titleClassName = "mb-2 text-title-large text-on-surface",
  subtitleClassName = "mb-10 text-body-large text-on-surface-var",
  supportClassName = "mt-10",
  desktopAsideClassName = "hidden lg:flex lg:items-center lg:px-16 lg:py-12 xl:px-20",
}) {
  const hasDesktopAside = Boolean(desktopAside);
  const innerClassName = hasDesktopAside
    ? [
        "h-full overflow-y-auto overscroll-y-contain",
        "grid place-items-center",
        "lg:mx-auto lg:max-w-[1440px] lg:grid-cols-[1.08fr_0.92fr] lg:place-items-stretch",
        layoutClassName,
      ]
        .filter(Boolean)
        .join(" ")
    : ["h-full overflow-y-auto overscroll-y-contain grid place-items-center", layoutClassName]
        .filter(Boolean)
        .join(" ");

  return (
    <div className={outerClassName}>
      <div className={innerClassName}>
        {hasDesktopAside ? (
          <section className={desktopAsideClassName}>{desktopAside}</section>
        ) : null}

        <section
          className={
            hasDesktopAside
              ? "grid min-h-full w-full place-items-center py-[calc(env(safe-area-inset-top)+40px)] lg:min-h-0 lg:px-12 lg:py-12"
              : "grid min-h-full w-full place-items-center"
          }
        >
          <div className={contentClassName}>
            <div className={contentWrapClassName}>
              <img
                src="/assets/images/afrimed_logo_stack.svg"
                alt={logoAlt}
                className={logoClassName}
                draggable="false"
              />

              <div className={headerClassName}>
                {title ? <h1 className={titleClassName}>{title}</h1> : null}
                {subtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
              </div>

              {children}
              {supportSlot ? <div className={supportClassName}>{supportSlot}</div> : null}
              {footerSlot}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
